// Action - state management
import * as actionTypes from "./actions";

const initialState = {
    loading: [],
    message: null,
    fullScreen: undefined
};

// ==============================|| SPINNER REDUCER ||============================== //

const spinnerReducer = (state = initialState, action) => {
    const { payload, type } = action || {};
    const { fullScreen, message } = payload || {};

    switch (type) {
        case actionTypes.SPINNER_END: {
            let loading = [...state.loading];
            loading.pop();

            return {
                ...state,
                loading,
                message: loading.length > 0 ? state.message : initialState.message,
                fullScreen: loading.length > 0 ? state.fullScreen : initialState.fullScreen
            };
        }
        case actionTypes.SPINNER_START: {
            let loading: boolean[] = [...state.loading];
            loading.push(true);

            return {
                ...state,
                loading,
                message: message ? message : initialState.message,
                fullScreen: fullScreen ? fullScreen : initialState.fullScreen
            };
        }
        default:
            return state;
    }
};

export const endSpinner = () => {
    return {
        type: actionTypes.SPINNER_END
    };
};

type StartSpinnerProps = {
    fullScreen: boolean;
    message?: string;
};

export const startSpinner = (props?: StartSpinnerProps) => {
    return {
        type: actionTypes.SPINNER_START,
        payload: props
    };
};

export default spinnerReducer;
